import React from 'react';
import { Container, Box } from '@mui/material';
import { Chat as ChatIcon, Timer as TimerIcon, AdminPanelSettings as AdminIcon } from '@mui/icons-material';
import FeatureCard from '../components/HomeFeatureCard';
import { useNavigate } from 'react-router-dom';
import { useAppRole } from '../hooks/useAppRole';


const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const isAdmin = useAppRole(['RPWA_Admin', 'RPWA_Super']);

  const features = [
    {
      icon: <TimerIcon />,
      title: "Start Assessment",
      description: "Complete roleplay scenarios assigned by your manager",
      onClick: () => navigate('/assessment'),
    },
    {
      icon: <ChatIcon />,
      title: "My Feedback", 
      description: "Review feedback from previous sessions",
      onClick: () => navigate('/feedback'),
    },
  ];

  // Conditionally add the admin feature if the user is an admin
  if (isAdmin) {
    features.push({
      icon: <AdminIcon />,
      title: "Admin Pane",
      description: "Manage users, assessments, and review analytics",
      onClick: () => navigate('/admin'),
    });
  }
  return (
    <Container maxWidth="xl" sx={{ py: 4, overflow: 'auto' }}>
      <Box
        sx={{
          display: 'flex',
          gap: 4,
          mt: 4,
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        {features.map((feature) => (
          <Box
            key={feature.title}
            sx={{
              flex: '1 1 300px',
              minWidth: 280,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <FeatureCard
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              onClick={feature.onClick}
            />
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default HomePage;